import React from 'react'

const ButtonPrimary = (prop) => {
   const url= prop.url
  return (
    <a href={`pdf/${url}`} download><button type="button" class="btn btn-primary">Descargar <i class="fa fa-download" aria-hidden="true"></i></button></a>
  )
}

export default ButtonPrimary